import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { InfiniteSlider } from '@hivebrite/design-system/InfiniteSlider';

import { InfiniteSliderItemComponent } from 'hb-builder/components/BuilderComponents/page/block/Gallery/components/InfiniteSlider/components/InfiniteSliderItemComponent';
import type { SliderItem } from 'hb-builder/components/BuilderComponents/page/block/Gallery/components/InfiniteSlider/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SliderItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/galleryItemAttributes';

export interface InfiniteSliderUiProps {
  item: SliderItem;
  subdomainNetworkUrl?: string;
  toggleDrawer?: (args: DocumentItem<SliderItemAttributes>) => void;
}

export type ComputedSliderItems = DocumentItem<SliderItemAttributes> &
  Pick<InfiniteSliderUiProps, 'subdomainNetworkUrl' | 'toggleDrawer'> & {
    numberOfItem: number;
    sliderItemAttributes?: SliderItemAttributes;
  };

const InfiniteSliderUi = ({
  item,
  subdomainNetworkUrl,
  toggleDrawer,
}: InfiniteSliderUiProps) => {
  const { attributes, children: items } = item;

  const computedItems: ComputedSliderItems[] = items.map((sliderItem) => ({
    sliderItemAttributes: attributes,
    numberOfItem: items.length,
    subdomainNetworkUrl,
    toggleDrawer,
    ...sliderItem,
  }));

  return (
    <SliderWrapper p={attributes?.containerPadding}>
      <InfiniteSlider
        items={computedItems}
        ItemComponent={InfiniteSliderItemComponent}
        perPageBreakpoints={{ s: 1, m: 3, l: 3, xl: 3 }}
      />
    </SliderWrapper>
  );
};

export default InfiniteSliderUi;

const SliderWrapper = styled(Box).attrs(() => ({
  width: '100%',
  display: 'block',
}))``;
